/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
/**
 * This mimics the mouse-click visual behavior for keyboard only users and screen readers.
 * Browsers do not apply the CSS psuedo-selector :active in those instances. So we need this
 * for our :active styles to show.
 *
 * Make sure to update a component's CSS to account for the presence of the [cds-active] attribute
 * in all instance where :active is defined.
 */
export function active() {
    return (target) => target.addInitializer((instance) => new ActiveController(instance));
}
export class ActiveController {
    constructor(host) {
        this.host = host;
        this.host.addController(this);
    }
    async hostConnected() {
        await this.host.updateComplete;
        this.host.addEventListener('keydown', (e) => this.emulateActive(e));
        this.host.addEventListener('mousedown', (e) => this.emulateActive(e));
        this.host.addEventListener('keyup', () => this.emulateInactive());
        this.host.addEventListener('blur', () => this.emulateInactive());
        this.host.addEventListener('mouseup', () => this.emulateInactive());
    }
    emulateActive(e) {
        if (!this.host.disabled) {
            this.host?.setAttribute('cds-active', '');
        }
        if (e.code === 'Space' && e.target === this.host) {
            e.preventDefault(); // prevent space bar scroll with button behavior
        }
    }
    emulateInactive() {
        this.host.removeAttribute('cds-active');
    }
}
